import { Controller } from '@hotwired/stimulus'

export default class extends Controller {
  notifySearchOrderFilterForm(e) {
    const { changes, submit } = e.params

    this.element.dispatchEvent(
      new CustomEvent('searchOrderFilterFormUpdate', {
        bubbles: true,
        composed: true,
        detail: {
          changes,
          submit
        }
      })
    )
  }
}
